import React from 'react';
import Badge from 'react-bootstrap/Badge';

function DatatableUser(props) {
    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';
        if (typeof dateStr === 'string' && dateStr.includes('T')) {
            const parts = dateStr.split('T')[0].split('-');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
        }
        return dateStr;
    };

    return (
        <div className="table-responsive">
            <table className='table table-bordered table-hover mb-0'>
                <thead>
                    <tr>
                        <th style={{ width: '60px' }}>SL</th>
                        <th>User Name</th>
                        <th>Contact</th>
                        <th>Date of Joining</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {props.userList && props.userList.length > 0 ? (
                        props.userList.map((item, index) => {
                            const date = item.date_of_joining || formatDate(item.created_at);
                            return (
                                <tr key={item.id || index}>
                                    <td><strong>#{item.id}</strong></td>
                                    <td>
                                        <div className="fw-bold">{item.name || 'User'}</div>
                                        {item.email && item.email !== 'N/A' && (
                                            <small className="text-muted d-block">{item.email}</small>
                                        )}
                                    </td>
                                    <td>{item.mobile || 'N/A'}</td>
                                    <td>{date}</td>
                                    <td>
                                        {item && item.status == 1 ? (
                                            <Badge bg="success">Active</Badge>
                                        ) : (
                                            <Badge bg="danger">Inactive</Badge>
                                        )}
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="5" className="text-center py-3 text-muted">No user records found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default DatatableUser;
